import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    maxHeight: Number,
    link: String
  }

  connect() {
    this.buttonTemplate = document.querySelector("[data-show-more-target=\"button\"")
    this.#isCollapsed(this.element)
  }

  #isCollapsed(container) {
    container.style.maxHeight = "none"
    container.classList.remove("collapsed")
    this.#removeButton(container)

    const actualHeight = container.offsetHeight
    const maxHeight = this.maxHeightValue > 0 ? this.maxHeightValue : window.innerHeight * 0.15
    const threshold = maxHeight * 1.2
    const shouldShowButton = actualHeight > threshold

    if (shouldShowButton) {
      container.style.maxHeight = `${maxHeight}px`
      container.classList.add("collapsed")
      if (this.hasLinkValue) {
        this.#appendLink(container)
      } else {
        this.#appendButton(container)
      }
    }
  }

  #appendLink(container) {
    const link = document.createElement("a")
    link.href = this.linkValue
    link.classList.add("show-more-button")
    link.innerText = "Show more"
    container.appendChild(link)
  }

  #appendButton(container) {
    const button = document.createElement("button")
    button.classList.add("show-more-button")
    button.innerText = "Show more"
    button.addEventListener("click", this.showMore.bind(this))
    container.appendChild(button)
  }

  #removeButton(container) {
    const button = container.querySelector(".show-more-button")
    if (button) {
      button.remove()
    }
  }

  showMore() {
    this.element.style.maxHeight = "none"
    this.element.classList.remove("collapsed")
    this.#removeButton(this.element)
  }
}
